/// <reference types="../../Scripts/Main.zepto_auction.js.src/Main.zepto_Auction" />

declare global {
    // eslint-disable-next-line no-var
    var loginPopupReceiverFunction: undefined | ((mode: any) => any);
}
window.loginPopupReceiverFunction = undefined;
function openLoginMode(mode: any) {
    if (typeof window.loginPopupReceiverFunction === "function")
        return window.loginPopupReceiverFunction(mode);
    console.error("No registered popup receiver");
}

export function newUserPopup(e?: Event | undefined | null) {
    if (e != null && typeof e.preventDefault == "function" && !window.isIE())
        e.preventDefault();

    openLoginMode("signup");

    return false;
}

export function loginPopup(e?: Event | undefined | null) {
    if (e != null && typeof e.preventDefault == "function" && !window.isIE())
        e.preventDefault();

    openLoginMode("login");

    return false;
}

export function openLoginOrSignupPopup(e?: Event | undefined | null) {
    if (e != null && typeof e.preventDefault == "function" && !window.isIE())
        e.preventDefault();

    openLoginMode("choice");

    return false;
}
